/*
 * fn: getPriceSourceTotal
 *
 * Gets total prices of a list of cards for a given priceSource
 *
 */
import { type CardIdType, type CardMapType } from '@/defs/card'
import { type PriceSourceType } from '@/defs/price'

type Props = {
  cardIds: CardIdType[]
  cardMap: CardMapType
  priceSource: PriceSourceType
}

export const getPriceSourceTotal = ({ cardIds, cardMap, priceSource }: Props) =>
  cardIds.reduce<number>((acc, cardId) => acc + (cardMap[cardId]?.priceSources?.[priceSource]?.price || 0), 0)
